// Lista de países para selector en formularios
import { Language } from '../types';

// Definir todos los países en todos los idiomas
const allCountries: Record<Language, Record<string, string>> = {
  es: {
    'AF': 'Afganistán',
    'AX': 'Åland',
    'AL': 'Albania',
    'DE': 'Alemania',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AI': 'Anguila',
    'AQ': 'Antártida',
    'AG': 'Antigua y Barbuda',
    'SA': 'Arabia Saudita',
    'DZ': 'Argelia',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AW': 'Aruba',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaiyán',
    'BS': 'Bahamas',
    'BD': 'Bangladés',
    'BB': 'Barbados',
    'BH': 'Baréin',
    'BE': 'Bélgica',
    'BZ': 'Belice',
    'BJ': 'Benín',
    'BM': 'Bermudas',
    'BY': 'Bielorrusia',
    'BO': 'Bolivia',
    'BQ': 'Bonaire, San Eustaquio y Saba',
    'BA': 'Bosnia y Herzegovina',
    'BW': 'Botsuana',
    'BR': 'Brasil',
    'BN': 'Brunéi',
    'BI': 'Burundi',
    'BT': 'Bután',
    'CV': 'Cabo Verde',
    'KH': 'Camboya',
    'CA': 'Canadá',
    'QA': 'Catar',
    'TD': 'Chad',
    'CL': 'Chile',
    'CN': 'China',
    'CY': 'Chipre',
    'CO': 'Colombia',
    'KM': 'Comoras',
    'KR': 'Corea del Sur',
    'CI': 'Costa de Marfil',
    'CR': 'Costa Rica',
    'CU': 'Cuba',
    'CW': 'Curazao',
    'DK': 'Dinamarca',
    'DM': 'Dominica',
    'EC': 'Ecuador',
    'EG': 'Egipto',
    'SV': 'El Salvador',
    'AE': 'Emiratos Árabes Unidos',
    'ER': 'Eritrea',
    'SK': 'Eslovaquia',
    'SI': 'Eslovenia',
    'ES': 'España',
    'US': 'Estados Unidos',
    'EE': 'Estonia',
    'ET': 'Etiopía',
    'FI': 'Finlandia',
    'FJ': 'Fiyi',
    'FR': 'Francia',
    'GA': 'Gabón',
    'GM': 'Gambia',
    'GE': 'Georgia',
    'GH': 'Ghana',
    'GI': 'Gibraltar',
    'GD': 'Granada',
    'GR': 'Grecia',
    'GL': 'Groenlandia',
    'GP': 'Guadalupe',
    'GU': 'Guam',
    'GT': 'Guatemala',
    'GF': 'Guayana Francesa',
    'GG': 'Guernsey',
    'GN': 'Guinea',
    'GW': 'Guinea-Bisáu',
    'GQ': 'Guinea Ecuatorial',
    'GY': 'Guyana',
    'HN': 'Honduras',
    'HK': 'Hong Kong',
    'HU': 'Hungría',
    'IN': 'India',
    'ID': 'Indonesia',
    'IQ': 'Irak',
    'IE': 'Irlanda',
    'BV': 'Isla Bouvet',
    'IM': 'Isla de Man',
    'CX': 'Isla de Navidad',
    'IS': 'Islandia',
    'KY': 'Islas Caimán',
    'CC': 'Islas Cocos',
    'CK': 'Islas Cook',
    'FO': 'Islas Feroe',
    'GS': 'Islas Georgias del Sur y Sandwich del Sur',
    'HM': 'Islas Heard y McDonald',
    'FK': 'Islas Malvinas',
    'MP': 'Islas Marianas del Norte',
    'MH': 'Islas Marshall',
    'PN': 'Islas Pitcairn',
    'SB': 'Islas Salomón',
    'TC': 'Islas Turcas y Caicos',
    'UM': 'Islas Ultramarinas Menores de los Estados Unidos',
    'VG': 'Islas Vírgenes Británicas',
    'VI': 'Islas Vírgenes de los Estados Unidos',
    'IL': 'Israel',
    'IT': 'Italia',
    'JP': 'Japón',
    'JE': 'Jersey',
    'JO': 'Jordania',
    'KZ': 'Kazajistán',
    'KG': 'Kirguistán',
    'KI': 'Kiribati',
    'KW': 'Kuwait',
    'LA': 'Laos',
    'LS': 'Lesoto',
    'LV': 'Letonia',
    'LB': 'Líbano',
    'LR': 'Liberia',
    'LY': 'Libia',
    'LI': 'Liechtenstein',
    'LT': 'Lituania',
    'LU': 'Luxemburgo',
    'MO': 'Macao',
    'MK': 'Macedonia del Norte',
    'MG': 'Madagascar',
    'MY': 'Malasia',
    'MW': 'Malaui',
    'MV': 'Maldivas',
    'MT': 'Malta',
    'MA': 'Marruecos',
    'MQ': 'Martinica',
    'MU': 'Mauricio',
    'MR': 'Mauritania',
    'YT': 'Mayotte',
    'MX': 'México',
    'FM': 'Micronesia',
    'MD': 'Moldavia',
    'MC': 'Mónaco',
    'MN': 'Mongolia',
    'ME': 'Montenegro',
    'MS': 'Montserrat',
    'MM': 'Birmania',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NE': 'Níger',
    'NU': 'Niue',
    'NF': 'Isla Norfolk',
    'NO': 'Noruega',
    'NC': 'Nueva Caledonia',
    'NZ': 'Nueva Zelanda',
    'OM': 'Omán',
    'NL': 'Países Bajos',
    'PK': 'Pakistán',
    'PW': 'Palaos',
    'PS': 'Palestina',
    'PA': 'Panamá',
    'PG': 'Papúa Nueva Guinea',
    'PY': 'Paraguay',
    'PE': 'Perú',
    'PF': 'Polinesia Francesa',
    'PL': 'Polonia',
    'PT': 'Portugal',
    'PR': 'Puerto Rico',
    'GB': 'Reino Unido',
    'EH': 'República Árabe Saharaui Democrática',
    'CF': 'República Centroafricana',
    'CZ': 'República Checa',
    'CD': 'República Democrática del Congo',
    'DO': 'República Dominicana',
    'RE': 'Reunión',
    'RW': 'Ruanda',
    'RO': 'Rumania',
    'RU': 'Rusia',
    'WS': 'Samoa',
    'AS': 'Samoa Americana',
    'BL': 'San Bartolomé',
    'KN': 'San Cristóbal y Nieves',
    'SM': 'San Marino',
    'MF': 'San Martín',
    'PM': 'San Pedro y Miquelón',
    'VC': 'San Vicente y las Granadinas',
    'SH': 'Santa Elena, Ascensión y Tristán de Acuña',
    'LC': 'Santa Lucía',
    'ST': 'Santo Tomé y Príncipe',
    'RS': 'Serbia',
    'SC': 'Seychelles',
    'SL': 'Sierra Leona',
    'SG': 'Singapur',
    'SX': 'San Martín',
    'SO': 'Somalia',
    'LK': 'Sri Lanka',
    'SZ': 'Suazilandia',
    'SD': 'Sudán',
    'SE': 'Suecia',
    'CH': 'Suiza',
    'SR': 'Surinam',
    'SJ': 'Svalbard y Jan Mayen',
    'TH': 'Tailandia',
    'TW': 'Taiwán (República de China)',
    'TJ': 'Tayikistán',
    'IO': 'Territorio Británico del Océano Índico',
    'TF': 'Tierras Australes y Antárticas Francesas',
    'TL': 'Timor Oriental',
    'TG': 'Togo',
    'TK': 'Tokelau',
    'TO': 'Tonga',
    'TT': 'Trinidad y Tobago',
    'TN': 'Túnez',
    'TM': 'Turkmenistán',
    'TV': 'Tuvalu',
    'UA': 'Ucrania',
    'UG': 'Uganda',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistán',
    'VU': 'Vanuatu',
    'VA': 'Ciudad del Vaticano',
    'WF': 'Wallis y Futuna',
    'DJ': 'Yibuti',
    'ZM': 'Zambia',
    'ZW': 'Zimbabue',
    'IR': 'Irán',
    'KP': 'Corea del Norte',
    'NG': 'Nigeria',
  },
  en: {
    'AF': 'Afghanistan',
    'AX': 'Åland Islands',
    'AL': 'Albania',
    'DE': 'Germany',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AQ': 'Antarctica',
    'AG': 'Antigua and Barbuda',
    'SA': 'Saudi Arabia',
    'DZ': 'Algeria',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AW': 'Aruba',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaijan',
    'BS': 'Bahamas',
    'BD': 'Bangladesh',
    'BB': 'Barbados',
    'BH': 'Bahrain',
    'BE': 'Belgium',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BM': 'Bermuda',
    'BY': 'Belarus',
    'BO': 'Bolivia',
    'BQ': 'Bonaire, Sint Eustatius and Saba',
    'BA': 'Bosnia and Herzegovina',
    'BW': 'Botswana',
    'BR': 'Brazil',
    'BN': 'Brunei',
    'BI': 'Burundi',
    'BT': 'Bhutan',
    'CV': 'Cape Verde',
    'KH': 'Cambodia',
    'CA': 'Canada',
    'QA': 'Qatar',
    'TD': 'Chad',
    'CL': 'Chile',
    'CN': 'China',
    'CY': 'Cyprus',
    'CO': 'Colombia',
    'KM': 'Comoros',
    'KR': 'South Korea',
    'CI': 'Ivory Coast',
    'CR': 'Costa Rica',
    'CU': 'Cuba',
    'CW': 'Curaçao',
    'DK': 'Denmark',
    'DM': 'Dominica',
    'EC': 'Ecuador',
    'EG': 'Egypt',
    'SV': 'El Salvador',
    'AE': 'United Arab Emirates',
    'ER': 'Eritrea',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'ES': 'Spain',
    'US': 'United States',
    'EE': 'Estonia',
    'ET': 'Ethiopia',
    'FI': 'Finland',
    'FJ': 'Fiji',
    'FR': 'France',
    'GA': 'Gabon',
    'GM': 'Gambia',
    'GE': 'Georgia',
    'GH': 'Ghana',
    'GI': 'Gibraltar',
    'GD': 'Grenada',
    'GR': 'Greece',
    'GL': 'Greenland',
    'GP': 'Guadeloupe',
    'GU': 'Guam',
    'GT': 'Guatemala',
    'GF': 'French Guiana',
    'GG': 'Guernsey',
    'GN': 'Guinea',
    'GW': 'Guinea-Bissau',
    'GQ': 'Equatorial Guinea',
    'GY': 'Guyana',
    'HN': 'Honduras',
    'HK': 'Hong Kong',
    'HU': 'Hungary',
    'IN': 'India',
    'ID': 'Indonesia',
    'IQ': 'Iraq',
    'IE': 'Ireland',
    'BV': 'Bouvet Island',
    'IM': 'Isle of Man',
    'CX': 'Christmas Island',
    'IS': 'Iceland',
    'KY': 'Cayman Islands',
    'CC': 'Cocos Islands',
    'CK': 'Cook Islands',
    'FO': 'Faroe Islands',
    'GS': 'South Georgia and the South Sandwich Islands',
    'HM': 'Heard Island and McDonald Islands',
    'FK': 'Falkland Islands',
    'MP': 'Northern Mariana Islands',
    'MH': 'Marshall Islands',
    'PN': 'Pitcairn Islands',
    'SB': 'Solomon Islands',
    'TC': 'Turks and Caicos Islands',
    'UM': 'United States Minor Outlying Islands',
    'VG': 'British Virgin Islands',
    'VI': 'U.S. Virgin Islands',
    'IL': 'Israel',
    'IT': 'Italy',
    'JP': 'Japan',
    'JE': 'Jersey',
    'JO': 'Jordan',
    'KZ': 'Kazakhstan',
    'KG': 'Kyrgyzstan',
    'KI': 'Kiribati',
    'KW': 'Kuwait',
    'LA': 'Laos',
    'LS': 'Lesotho',
    'LV': 'Latvia',
    'LB': 'Lebanon',
    'LR': 'Liberia',
    'LY': 'Libya',
    'LI': 'Liechtenstein',
    'LT': 'Lithuania',
    'LU': 'Luxembourg',
    'MO': 'Macao',
    'MK': 'North Macedonia',
    'MG': 'Madagascar',
    'MY': 'Malaysia',
    'MW': 'Malawi',
    'MV': 'Maldives',
    'MT': 'Malta',
    'MA': 'Morocco',
    'MQ': 'Martinique',
    'MU': 'Mauritius',
    'MR': 'Mauritania',
    'YT': 'Mayotte',
    'MX': 'Mexico',
    'FM': 'Micronesia',
    'MD': 'Moldova',
    'MC': 'Monaco',
    'MN': 'Mongolia',
    'ME': 'Montenegro',
    'MS': 'Montserrat',
    'MM': 'Myanmar',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NE': 'Niger',
    'NU': 'Niue',
    'NF': 'Norfolk Island',
    'NO': 'Norway',
    'NC': 'New Caledonia',
    'NZ': 'New Zealand',
    'OM': 'Oman',
    'NL': 'Netherlands',
    'PK': 'Pakistan',
    'PW': 'Palau',
    'PS': 'Palestine',
    'PA': 'Panama',
    'PG': 'Papua New Guinea',
    'PY': 'Paraguay',
    'PE': 'Peru',
    'PF': 'French Polynesia',
    'PL': 'Poland',
    'PT': 'Portugal',
    'PR': 'Puerto Rico',
    'GB': 'United Kingdom',
    'EH': 'Western Sahara',
    'CF': 'Central African Republic',
    'CZ': 'Czech Republic',
    'CD': 'Democratic Republic of the Congo',
    'DO': 'Dominican Republic',
    'RE': 'Réunion',
    'RW': 'Rwanda',
    'RO': 'Romania',
    'RU': 'Russia',
    'WS': 'Samoa',
    'AS': 'American Samoa',
    'BL': 'Saint Barthélemy',
    'KN': 'Saint Kitts and Nevis',
    'SM': 'San Marino',
    'MF': 'Saint Martin',
    'PM': 'Saint Pierre and Miquelon',
    'VC': 'Saint Vincent and the Grenadines',
    'SH': 'Saint Helena, Ascension and Tristan da Cunha',
    'LC': 'Saint Lucia',
    'ST': 'São Tomé and Príncipe',
    'RS': 'Serbia',
    'SC': 'Seychelles',
    'SL': 'Sierra Leone',
    'SG': 'Singapore',
    'SX': 'Sint Maarten',
    'SO': 'Somalia',
    'LK': 'Sri Lanka',
    'SZ': 'Eswatini',
    'SD': 'Sudan',
    'SE': 'Sweden',
    'CH': 'Switzerland',
    'SR': 'Suriname',
    'SJ': 'Svalbard and Jan Mayen',
    'TH': 'Thailand',
    'TW': 'Taiwan',
    'TJ': 'Tajikistan',
    'IO': 'British Indian Ocean Territory',
    'TF': 'French Southern Territories',
    'TL': 'East Timor',
    'TG': 'Togo',
    'TK': 'Tokelau',
    'TO': 'Tonga',
    'TT': 'Trinidad and Tobago',
    'TN': 'Tunisia',
    'TM': 'Turkmenistan',
    'TV': 'Tuvalu',
    'UA': 'Ukraine',
    'UG': 'Uganda',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistan',
    'VU': 'Vanuatu',
    'VA': 'Vatican City',
    'WF': 'Wallis and Futuna',
    'DJ': 'Djibouti',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe',
    'IR': 'Iran',
    'KP': 'North Korea',
    'NG': 'Nigeria',
  },
  fr: {
    'AF': 'Afghanistan',
    'AX': 'Åland',
    'AL': 'Albanie',
    'DE': 'Allemagne',
    'AD': 'Andorre',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AQ': 'Antarctique',
    'AG': 'Antigua-et-Barbuda',
    'SA': 'Arabie saoudite',
    'DZ': 'Algérie',
    'AR': 'Argentine',
    'AM': 'Arménie',
    'AW': 'Aruba',
    'AU': 'Australie',
    'AT': 'Autriche',
    'AZ': 'Azerbaïdjan',
    'BS': 'Bahamas',
    'BD': 'Bangladesh',
    'BB': 'Barbade',
    'BH': 'Bahreïn',
    'BE': 'Belgique',
    'BZ': 'Belize',
    'BJ': 'Bénin',
    'BM': 'Bermudes',
    'BY': 'Biélorussie',
    'BO': 'Bolivie',
    'BQ': 'Bonaire, Saint-Eustache et Saba',
    'BA': 'Bosnie-Herzégovine',
    'BW': 'Botswana',
    'BR': 'Brésil',
    'BN': 'Brunéi',
    'BI': 'Burundi',
    'BT': 'Bhoutan',
    'CV': 'Cap-Vert',
    'KH': 'Cambodge',
    'CA': 'Canada',
    'QA': 'Qatar',
    'TD': 'Tchad',
    'CL': 'Chili',
    'CN': 'Chine',
    'CY': 'Chypre',
    'CO': 'Colombie',
    'KM': 'Comores',
    'KR': 'Corée du Sud',
    'CI': 'Côte d\'Ivoire',
    'CR': 'Costa Rica',
    'CU': 'Cuba',
    'CW': 'Curaçao',
    'DK': 'Danemark',
    'DM': 'Dominique',
    'EC': 'Équateur',
    'EG': 'Égypte',
    'SV': 'El Salvador',
    'AE': 'Émirats arabes unis',
    'ER': 'Érythrée',
    'SK': 'Slovaquie',
    'SI': 'Slovénie',
    'ES': 'Espagne',
    'US': 'États-Unis',
    'EE': 'Estonie',
    'ET': 'Éthiopie',
    'FI': 'Finlande',
    'FJ': 'Fidji',
    'FR': 'France',
    'GA': 'Gabon',
    'GM': 'Gambie',
    'GE': 'Géorgie',
    'GH': 'Ghana',
    'GI': 'Gibraltar',
    'GD': 'Grenade',
    'GR': 'Grèce',
    'GL': 'Groenland',
    'GP': 'Guadeloupe',
    'GU': 'Guam',
    'GT': 'Guatemala',
    'GF': 'Guyane française',
    'GG': 'Guernesey',
    'GN': 'Guinée',
    'GW': 'Guinée-Bissau',
    'GQ': 'Guinée équatoriale',
    'GY': 'Guyana',
    'HN': 'Honduras',
    'HK': 'Hong Kong',
    'HU': 'Hongrie',
    'IN': 'Inde',
    'ID': 'Indonésie',
    'IQ': 'Irak',
    'IE': 'Irlande',
    'BV': 'Île Bouvet',
    'IM': 'Île de Man',
    'CX': 'Île Christmas',
    'IS': 'Islande',
    'KY': 'Îles Caïmans',
    'CC': 'Îles Cocos',
    'CK': 'Îles Cook',
    'FO': 'Îles Féroé',
    'GS': 'Géorgie du Sud-et-les Îles Sandwich du Sud',
    'HM': 'Îles Heard-et-MacDonald',
    'FK': 'Îles Malouines',
    'MP': 'Îles Mariannes du Nord',
    'MH': 'Îles Marshall',
    'PN': 'Îles Pitcairn',
    'SB': 'Îles Salomon',
    'TC': 'Îles Turques-et-Caïques',
    'UM': 'Îles mineures éloignées des États-Unis',
    'VG': 'Îles Vierges britanniques',
    'VI': 'Îles Vierges des États-Unis',
    'IL': 'Israël',
    'IT': 'Italie',
    'JP': 'Japon',
    'JE': 'Jersey',
    'JO': 'Jordanie',
    'KZ': 'Kazakhstan',
    'KG': 'Kirghizistan',
    'KI': 'Kiribati',
    'KW': 'Koweït',
    'LA': 'Laos',
    'LS': 'Lesotho',
    'LV': 'Lettonie',
    'LB': 'Liban',
    'LR': 'Libéria',
    'LY': 'Libye',
    'LI': 'Liechtenstein',
    'LT': 'Lituanie',
    'LU': 'Luxembourg',
    'MO': 'Macao',
    'MK': 'Macédoine du Nord',
    'MG': 'Madagascar',
    'MY': 'Malaisie',
    'MW': 'Malawi',
    'MV': 'Maldives',
    'MT': 'Malte',
    'MA': 'Maroc',
    'MQ': 'Martinique',
    'MU': 'Maurice',
    'MR': 'Mauritanie',
    'YT': 'Mayotte',
    'MX': 'Mexique',
    'FM': 'Micronésie',
    'MD': 'Moldavie',
    'MC': 'Monaco',
    'MN': 'Mongolie',
    'ME': 'Monténégro',
    'MS': 'Montserrat',
    'MM': 'Myanmar',
    'NR': 'Nauru',
    'NP': 'Népal',
    'NE': 'Niger',
    'NU': 'Niue',
    'NF': 'Île Norfolk',
    'NO': 'Norvège',
    'NC': 'Nouvelle-Calédonie',
    'NZ': 'Nouvelle-Zélande',
    'OM': 'Oman',
    'NL': 'Pays-Bas',
    'PK': 'Pakistan',
    'PW': 'Palaos',
    'PS': 'Palestine',
    'PA': 'Panama',
    'PG': 'Papouasie-Nouvelle-Guinée',
    'PY': 'Paraguay',
    'PE': 'Pérou',
    'PF': 'Polynésie française',
    'PL': 'Pologne',
    'PT': 'Portugal',
    'PR': 'Porto Rico',
    'GB': 'Royaume-Uni',
    'EH': 'Sahara occidental',
    'CF': 'République centrafricaine',
    'CZ': 'République tchèque',
    'CD': 'République démocratique du Congo',
    'DO': 'République dominicaine',
    'RE': 'La Réunion',
    'RW': 'Rwanda',
    'RO': 'Roumanie',
    'RU': 'Russie',
    'WS': 'Samoa',
    'AS': 'Samoa américaines',
    'BL': 'Saint-Barthélemy',
    'KN': 'Saint-Kitts-et-Nevis',
    'SM': 'Saint-Marin',
    'MF': 'Saint-Martin',
    'PM': 'Saint-Pierre-et-Miquelon',
    'VC': 'Saint-Vincent-et-les-Grenadines',
    'SH': 'Sainte-Hélène, Ascension et Tristan da Cunha',
    'LC': 'Sainte-Lucie',
    'ST': 'Sao Tomé-et-Principe',
    'RS': 'Serbie',
    'SC': 'Seychelles',
    'SL': 'Sierra Leone',
    'SG': 'Singapour',
    'SX': 'Saint-Martin',
    'SO': 'Somalie',
    'LK': 'Sri Lanka',
    'SZ': 'Eswatini',
    'SD': 'Soudan',
    'SE': 'Suède',
    'CH': 'Suisse',
    'SR': 'Suriname',
    'SJ': 'Svalbard et Jan Mayen',
    'TH': 'Thaïlande',
    'TW': 'Taïwan',
    'TJ': 'Tadjikistan',
    'IO': 'Territoire britannique de l\'océan Indien',
    'TF': 'Terres australes et antarctiques françaises',
    'TL': 'Timor oriental',
    'TG': 'Togo',
    'TK': 'Tokelau',
    'TO': 'Tonga',
    'TT': 'Trinité-et-Tobago',
    'TN': 'Tunisie',
    'TM': 'Turkménistan',
    'TV': 'Tuvalu',
    'UA': 'Ukraine',
    'UG': 'Ouganda',
    'UY': 'Uruguay',
    'UZ': 'Ouzbékistan',
    'VU': 'Vanuatu',
    'VA': 'Vatican',
    'WF': 'Wallis-et-Futuna',
    'DJ': 'Djibouti',
    'ZM': 'Zambie',
    'ZW': 'Zimbabwe',
    'IR': 'Iran',
    'KP': 'Corée du Nord',
    'NG': 'Nigeria',
  },
  pt: {
    'AF': 'Afeganistão',
    'AX': 'Ilhas Åland',
    'AL': 'Albânia',
    'DE': 'Alemanha',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AQ': 'Antártida',
    'AG': 'Antígua e Barbuda',
    'SA': 'Arábia Saudita',
    'DZ': 'Argélia',
    'AR': 'Argentina',
    'AM': 'Armênia',
    'AW': 'Aruba',
    'AU': 'Austrália',
    'AT': 'Áustria',
    'AZ': 'Azerbaijão',
    'BS': 'Bahamas',
    'BD': 'Bangladesh',
    'BB': 'Barbados',
    'BH': 'Bahrein',
    'BE': 'Bélgica',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BM': 'Bermudas',
    'BY': 'Bielorrússia',
    'BO': 'Bolívia',
    'BQ': 'Bonaire, Santo Eustáquio e Saba',
    'BA': 'Bósnia e Herzegovina',
    'BW': 'Botsuana',
    'BR': 'Brasil',
    'BN': 'Brunei',
    'BI': 'Burundi',
    'BT': 'Butão',
    'CV': 'Cabo Verde',
    'KH': 'Camboja',
    'CA': 'Canadá',
    'QA': 'Catar',
    'TD': 'Chade',
    'CL': 'Chile',
    'CN': 'China',
    'CY': 'Chipre',
    'CO': 'Colômbia',
    'KM': 'Comores',
    'KR': 'Coreia do Sul',
    'CI': 'Costa do Marfim',
    'CR': 'Costa Rica',
    'CU': 'Cuba',
    'CW': 'Curaçao',
    'DK': 'Dinamarca',
    'DM': 'Dominica',
    'EC': 'Equador',
    'EG': 'Egito',
    'SV': 'El Salvador',
    'AE': 'Emirados Árabes Unidos',
    'ER': 'Eritreia',
    'SK': 'Eslováquia',
    'SI': 'Eslovênia',
    'ES': 'Espanha',
    'US': 'Estados Unidos',
    'EE': 'Estônia',
    'ET': 'Etiópia',
    'FI': 'Finlândia',
    'FJ': 'Fiji',
    'FR': 'França',
    'GA': 'Gabão',
    'GM': 'Gâmbia',
    'GE': 'Geórgia',
    'GH': 'Gana',
    'GI': 'Gibraltar',
    'GD': 'Granada',
    'GR': 'Grécia',
    'GL': 'Groenlândia',
    'GP': 'Guadalupe',
    'GU': 'Guam',
    'GT': 'Guatemala',
    'GF': 'Guiana Francesa',
    'GG': 'Guernsey',
    'GN': 'Guiné',
    'GW': 'Guiné-Bissau',
    'GQ': 'Guiné Equatorial',
    'GY': 'Guiana',
    'HN': 'Honduras',
    'HK': 'Hong Kong',
    'HU': 'Hungria',
    'IN': 'Índia',
    'ID': 'Indonésia',
    'IQ': 'Iraque',
    'IE': 'Irlanda',
    'BV': 'Ilha Bouvet',
    'IM': 'Ilha de Man',
    'CX': 'Ilha Christmas',
    'IS': 'Islândia',
    'KY': 'Ilhas Cayman',
    'CC': 'Ilhas Cocos',
    'CK': 'Ilhas Cook',
    'FO': 'Ilhas Faroé',
    'GS': 'Ilhas Geórgia do Sul e Sandwich do Sul',
    'HM': 'Ilhas Heard e McDonald',
    'FK': 'Ilhas Malvinas',
    'MP': 'Ilhas Marianas do Norte',
    'MH': 'Ilhas Marshall',
    'PN': 'Ilhas Pitcairn',
    'SB': 'Ilhas Salomão',
    'TC': 'Ilhas Turks e Caicos',
    'UM': 'Ilhas Menores Distantes dos Estados Unidos',
    'VG': 'Ilhas Virgens Britânicas',
    'VI': 'Ilhas Virgens Americanas',
    'IL': 'Israel',
    'IT': 'Itália',
    'JP': 'Japão',
    'JE': 'Jersey',
    'JO': 'Jordânia',
    'KZ': 'Cazaquistão',
    'KG': 'Quirguistão',
    'KI': 'Kiribati',
    'KW': 'Kuwait',
    'LA': 'Laos',
    'LS': 'Lesoto',
    'LV': 'Letônia',
    'LB': 'Líbano',
    'LR': 'Libéria',
    'LY': 'Líbia',
    'LI': 'Liechtenstein',
    'LT': 'Lituânia',
    'LU': 'Luxemburgo',
    'MO': 'Macau',
    'MK': 'Macedônia do Norte',
    'MG': 'Madagascar',
    'MY': 'Malásia',
    'MW': 'Malawi',
    'MV': 'Maldivas',
    'MT': 'Malta',
    'MA': 'Marrocos',
    'MQ': 'Martinica',
    'MU': 'Maurício',
    'MR': 'Mauritânia',
    'YT': 'Mayotte',
    'MX': 'México',
    'FM': 'Micronésia',
    'MD': 'Moldávia',
    'MC': 'Mônaco',
    'MN': 'Mongólia',
    'ME': 'Montenegro',
    'MS': 'Montserrat',
    'MM': 'Myanmar',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NE': 'Níger',
    'NU': 'Niue',
    'NF': 'Ilha Norfolk',
    'NO': 'Noruega',
    'NC': 'Nova Caledônia',
    'NZ': 'Nova Zelândia',
    'OM': 'Omã',
    'NL': 'Países Baixos',
    'PK': 'Paquistão',
    'PW': 'Palau',
    'PS': 'Palestina',
    'PA': 'Panamá',
    'PG': 'Papua-Nova Guiné',
    'PY': 'Paraguai',
    'PE': 'Peru',
    'PF': 'Polinésia Francesa',
    'PL': 'Polônia',
    'PT': 'Portugal',
    'PR': 'Porto Rico',
    'GB': 'Reino Unido',
    'EH': 'Saara Ocidental',
    'CF': 'República Centro-Africana',
    'CZ': 'República Tcheca',
    'CD': 'República Democrática do Congo',
    'DO': 'República Dominicana',
    'RE': 'Reunião',
    'RW': 'Ruanda',
    'RO': 'Romênia',
    'RU': 'Rússia',
    'WS': 'Samoa',
    'AS': 'Samoa Americana',
    'BL': 'São Bartolomeu',
    'KN': 'São Cristóvão e Nevis',
    'SM': 'San Marino',
    'MF': 'São Martinho',
    'PM': 'São Pedro e Miquelon',
    'VC': 'São Vicente e Granadinas',
    'SH': 'Santa Helena, Ascensão e Tristão da Cunha',
    'LC': 'Santa Lúcia',
    'ST': 'São Tomé e Príncipe',
    'RS': 'Sérvia',
    'SC': 'Seychelles',
    'SL': 'Serra Leoa',
    'SG': 'Singapura',
    'SX': 'Sint Maarten',
    'SO': 'Somália',
    'LK': 'Sri Lanka',
    'SZ': 'Eswatini',
    'SD': 'Sudão',
    'SE': 'Suécia',
    'CH': 'Suíça',
    'SR': 'Suriname',
    'SJ': 'Svalbard e Jan Mayen',
    'TH': 'Tailândia',
    'TW': 'Taiwan',
    'TJ': 'Tadjiquistão',
    'IO': 'Território Britânico do Oceano Índico',
    'TF': 'Terras Austrais e Antárticas Francesas',
    'TL': 'Timor-Leste',
    'TG': 'Togo',
    'TK': 'Tokelau',
    'TO': 'Tonga',
    'TT': 'Trinidad e Tobago',
    'TN': 'Tunísia',
    'TM': 'Turcomenistão',
    'TV': 'Tuvalu',
    'UA': 'Ucrânia',
    'UG': 'Uganda',
    'UY': 'Uruguai',
    'UZ': 'Uzbequistão',
    'VU': 'Vanuatu',
    'VA': 'Vaticano',
    'WF': 'Wallis e Futuna',
    'DJ': 'Djibuti',
    'ZM': 'Zâmbia',
    'ZW': 'Zimbábue',
    'IR': 'Irã',
    'KP': 'Coreia do Norte',
    'NG': 'Nigéria',
  }
};

// Función para crear la lista de países con USA y México al principio según el idioma
function createCountriesList(language: Language): Record<string, string> {
  const countriesInLanguage = allCountries[language];
  const sortedCountries: Record<string, string> = {};
  
  // Agregar Estados Unidos y México al principio
  sortedCountries['US'] = countriesInLanguage['US'];
  sortedCountries['MX'] = countriesInLanguage['MX'];
  
  // Agregar el resto de países en orden alfabético
  const sortedEntries = Object.entries(countriesInLanguage)
    .sort((a, b) => a[1].localeCompare(b[1], language === 'es' ? 'es' : language === 'en' ? 'en' : language === 'fr' ? 'fr' : 'pt'));
  
  for (const [code, name] of sortedEntries) {
    sortedCountries[code] = name;
  }
  
  return sortedCountries;
}

// Función para obtener la lista de países según el idioma actual
export const getCountries = (language: Language = 'es'): Record<string, string> => {
  return createCountriesList(language);
};

// Exportar la lista de países en español por defecto (para compatibilidad con código existente)
const countries = createCountriesList('es');

export default countries;